var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search-icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3335 1.66671C3.75617 1.66671 1.66683 3.75605 1.66683 6.33337C1.66683 8.9107 3.75617 11 6.3335 11C7.59079 11 8.73196 10.5028 9.57109 9.6943C9.58864 9.67148 9.60786 9.64954 9.62876 9.62864C9.64966 9.60774 9.6716 9.58851 9.69442 9.57097C10.5029 8.73184 11.0002 7.59067 11.0002 6.33337C11.0002 3.75605 8.91083 1.66671 6.3335 1.66671ZM11.0214 10.0785C11.8425 9.05205 12.3335 7.75005 12.3335 6.33337C12.3335 3.01967 9.6472 0.333374 6.3335 0.333374C3.01979 0.333374 0.333496 3.01967 0.333496 6.33337C0.333496 9.64708 3.01979 12.3334 6.3335 12.3334C7.75017 12.3334 9.05217 11.8424 10.0786 11.0213L12.5288 13.4714C12.7891 13.7318 13.2112 13.7318 13.4716 13.4714C13.7319 13.2111 13.7319 12.789 13.4716 12.5286L11.0214 10.0785Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.ab715019.svg";
export { ForwardRef as ReactComponent };